import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { loginHr } from "../../api/api";
import "./authcustom.css";
import { Link } from "react-router-dom";

function HrLogin() {
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const popupTypeFromState = location.state?.popupType;
    const popupMessageFromState = location.state?.popupMessage;

    if (popupTypeFromState && popupMessageFromState) {
      setPopupType(popupTypeFromState);
      setSuccess(popupTypeFromState === "success" ? popupMessageFromState : "");
      setError(popupTypeFromState === "error" ? popupMessageFromState : "");
      setShowPopup(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setShowPopup(false);
    try {
      // Always send role: 'hr' to backend
      const payload = { ...form, role: 'hr' };
      const response = await loginHr(payload);
      // Save token and role to localStorage
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
        if (response.data.user && response.data.user.role) {
          localStorage.setItem("role", response.data.user.role);
        } else {
          localStorage.setItem("role", "hr");
        }
      }
      setSuccess(response.data.message || "Login successful");
      setPopupType("success");
      setShowPopup(true);
      setTimeout(() => setSuccess("") , 3000);
      setTimeout(() => navigate("/hr-login-panel", { replace: true }), 1200);
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
      setPopupType("error");
      setShowPopup(true);
      setTimeout(() => setError("") , 3000);
    }
  };

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
        setSuccess("");
        setError("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '60px' }}>
      <div className="auth-form-container">
      <h2>HR Login</h2>
      <form onSubmit={handleSubmit}>
        <label className="auth-label">Mobile or Email
          <input name="identifier" type="text" placeholder="Enter mobile or email" value={form.identifier} onChange={handleChange} required className="auth-input" />
        </label>
        <label className="auth-label">Password
          <div style={{ position: "relative" }}>
            <input name="password" type={showPassword ? "text" : "password"} placeholder="Enter your password" value={form.password} onChange={handleChange} required className="auth-input" autoComplete="current-password" />
            <button type="button" className="auth-show-btn" onClick={() => setShowPassword(s => !s)} tabIndex={-1} aria-label={showPassword ? "Hide password" : "Show password"}>
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
        </label>
        <button type="submit">Login</button>
      </form>
      <div className="auth-link-container">
        <span>Not registered?</span>
        <Link to="/hr-register" className="auth-link">Create an HR account</Link>
      </div>
      {/* Side message box for success/error */}
      <div style={{ position: 'fixed', top: 30, right: 30, zIndex: 120000 }}>
        {showPopup && popupType === "success" && success && (
          <div style={{ background: '#4caf50', color: 'white', padding: '12px 24px', borderRadius: 6, boxShadow: '0 2px 8px #0002', marginBottom: 8, minWidth: 180, textAlign: 'center', fontWeight: 500 }}>
            {success}
          </div>
        )}
        {showPopup && popupType === "error" && error && (
          <div style={{ background: '#f44336', color: 'white', padding: '12px 24px', borderRadius: 6, boxShadow: '0 2px 8px #0002', minWidth: 180, textAlign: 'center', fontWeight: 500 }}>
            {error}
          </div>
        )}
      </div>
      </div>
    </div>
  );
}

export default HrLogin;
